class NewsletterForm extends HTMLElement {
    constructor() {
        super();

        this.bindSubmitEvent();
        this.checkEmailExist();
    }

    bindSubmitEvent() {
        this.querySelector('form').addEventListener('submit', (e) => {
            this.querySelector('button[type=submit]').classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        });
    }

    checkEmailExist() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if(params['form_type'] && params['form_type'] === 'customer' && params['customer_posted'] === undefined && this.querySelector("input[type=email]").value) {
            document.getElementById('ContactFooter-error-exist').style.display = ''
        }
    }
}

customElements.define('newsletter-form', NewsletterForm);